<!--
 * @Description: 无数据空占位提示组件
 * @Author:sunhuihong
 * @Date: 2022-07-19 08:33:29
 * @LastEditTime: 2022-11-04 13:34:36
-->
<template>
  <div class="body" :style="{ height: styleHeight + 'px' }">
    <div class="body-header">
      <span style="font-weight: 600; color: #333333">{{ title }}</span>
    </div>
    <el-empty class="empty-img" description="暂无数据"></el-empty>
  </div>
</template>

<script>
export default {
  props: ["title", "styleHeight"]
};
</script>

<style scoped>
.body {
  border-radius: 6px;
  border: 1px solid #d7dde5;
}

.body-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #d7dde5;
}

.empty-img {
  margin-top: 40px;
}
</style>





// WEBPACK FOOTER //
// src/components/overview/components/EmptyData.vue